import { useEffect, useRef, useState } from 'react';

import { Box } from '@bcp-nextgen-dx-component-factory/design-system';
import { AppLayout, Banner, Footer } from '@components';
import { AppHelper, UIHelper } from '@helpers';

import { LoginForm } from './loginForm';
import { LoginSkeleton } from './loginSkeleton';

export const LoginScreenMobile = ({ isLoading }: { isLoading: boolean }) => {
	/* when reloading app, the block should be expanded */
	const isBeRedirect = AppHelper.isBeRedirect;
	const [isBannerCollapsed, setIsBannerCollapsed] = useState(isBeRedirect);
	const divRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (isBeRedirect) {
			setIsBannerCollapsed(true);
		}
	}, [isBeRedirect]);

	useEffect(() => {
		if (isBannerCollapsed) {
			divRef.current?.scrollIntoView();
		}
	}, [isBannerCollapsed]);

	if (isLoading) {
		return <LoginSkeleton />;
	}

	return (
		<AppLayout styles={{ overflowY: 'auto', height: '100vh' }}>
			<Banner isCollapsed={isBannerCollapsed} />

			<Box
				styles={{
					flex: 1,
					flexDirection: 'column',
					zIndex: 1,
					background: '#fff',
					overflowY: 'auto',
				}}
			>
				<div ref={divRef} />

				<LoginForm
					onAliasOpenContentButtonClick={() => setIsBannerCollapsed(true)}
					onAliasClosedContentLinkClick={() => setIsBannerCollapsed(false)}
					styles={{
						flex: 1,
						padding: UIHelper.rem(48, 24),
						gap: UIHelper.rem(40),
						maxWidth: UIHelper.rem(510),
					}}
				/>
			</Box>

			<Footer />
		</AppLayout>
	);
};
